import type { AuthenticationAccessRight } from "src/authentication/objects/AuthenticationToken";

export class HumanoidAccessRight {
  public static VIEW_HUMANOID: AuthenticationAccessRight = ({
    menuDisplayLevel,
  }) => menuDisplayLevel === 0;
}
